import dayjs from 'dayjs'
import { getS3UrlForAttachment } from '../../taskRefactored/tasks.slice'
import { uploadAttachmentToAWS } from '../../taskRefactored/tasks.service'

export const validateClientProfileImage = (file) => {
    if (!file) return { ok: false, reason: 'No file selected' }

    const isPng = file.type === 'image/png'
    const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg'
    const isWebp = file.type === 'image/webp'

    if (!isPng && !isJpeg && !isWebp) {
        return { ok: false, reason: 'Use a PNG, JPEG, or WebP image.' }
    }

    const maxBytes = 5 * 1024 * 1024
    if (file.size > maxBytes) {
        return { ok: false, reason: 'Image must be under 5MB.' }
    }

    return { ok: true }
}

export const uploadClientImageToS3 = async (file, dispatch) => {
    if (!file) throw new Error('No file selected')

    if (typeof window !== 'undefined' && !window.Buffer) {
        window.Buffer = require('buffer').Buffer
    }

    const ext = file.name.split('.').pop() || 'png'
    const baseName = file.name.split('.')[0] || 'client_avatar'
    const nameChange = `${baseName}_${dayjs().unix()}.${ext}`

    const presignPayload = {
        data: [
            {
                filename: nameChange,
                contentType: file.type || 'image/png',
            },
        ],
    }

    const s3Result = await dispatch(getS3UrlForAttachment(presignPayload))
    const resBody = s3Result?.payload?.data
    // Current API: { success, message, data: [{ uploadUrl, publicLink }] }
    // Legacy API:  { status: 200, data: { data: [{ uploadUrl, publicLink }] } }
    const ok =
        resBody?.success === true ||
        resBody?.status === 200 ||
        resBody?.status === '200'
    if (!ok) {
        throw new Error(resBody?.message || 'Could not get upload URL')
    }

    const files = Array.isArray(resBody?.data)
        ? resBody.data
        : Array.isArray(resBody?.data?.data)
          ? resBody.data.data
          : []
    const uploadUrl = files?.[0]?.uploadUrl
    const publicLink = files?.[0]?.publicLink

    if (!uploadUrl || !publicLink) {
        throw new Error('Upload URL missing')
    }

    const putResult = await uploadAttachmentToAWS({
        url: uploadUrl,
        data: file,
    })
    // fetch Response exposes `.ok`; some callers may return a plain object
    const putOk =
        putResult?.data?.ok === true || putResult?.data?.status === 200
    if (!putOk) {
        throw new Error('Upload to storage failed')
    }

    return publicLink
}

/** Upload a bundled default avatar (webpack asset URL) to S3 for persistence */
export const uploadDefaultAvatarAssetToS3 = async (
    avatarSrc,
    avatarId,
    dispatch
) => {
    const response = await fetch(avatarSrc)
    if (!response.ok) {
        throw new Error('Could not load default avatar')
    }
    const blob = await response.blob()
    const file = new File([blob], `${avatarId || 'avatar'}.png`, {
        type: blob.type || 'image/png',
    })
    return uploadClientImageToS3(file, dispatch)
}
